@for (warningType of warningTypes; track warningType; let index = $index) {
  <mat-card appearance="outlined" class="warning-card"
    [draggable]="true"
    (dragstart)="onDragStart(index)"
    (dragenter)="onDragEnter(index)"
    (dragend)="onDragEnd()"
    [matTooltip]="getTooltip(warningType)"
    (click)="itemSelected(warningType)"
    [ngClass]="{
        'from-here': index === fromIndex,
        'to-here': index === toIndex
    }"
    >
    <div class="main-column">
      <div class="description-row">
        <div class="warning-icon">
          <app-warning-icon [messageType]="warningType"></app-warning-icon>
        </div>
        <div class="warning-description" [innerHtml]="getHeader(warningType)"></div>
        <div class="warning-icon">
          <!-- Empty div to center warning-description div correctly -->
        </div>
      </div>
      <div class="warning-count-row">
        {{getWarningCount(warningType)}}
      </div>
    </div>
    <div class="list-column">
      <div class="list">
        <div class="vehicles-with-warning">
          @for (inventoryNumber of getTopInventoryNumbersForWarningType(warningType); track $index) {
            <div class="vehicle" [innerHtml]="inventoryNumber"></div>
          }
        </div>
      </div>
    </div>
  </mat-card>
}
